import { createIcon } from './factory'
import Icon from './stack-simple.svg?react'

export const StackSimple = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
